import { LinearProgress, LinearProgressProps } from "@mui/material";

/** Small wrapper for the Mui LinearProgress component with FARO style */
export function FaroLinearProgress({
  value,
  variant,
}: LinearProgressProps): JSX.Element {
  return (
    <LinearProgress
      sx={{
        mt: 1,
        "& .MuiLinearProgress-bar": {
          background: (theme) => theme.palette.primary.main,
        },
      }}
      variant={variant}
      value={value}
    />
  );
}
